<div class="connecting-container" [@fadeInOut] >
    <div class="connecting-wl">
        <span class="k-icon k-i-loading"></span>
        <p class="text">{{ loadingService.message }}</p>
    </div>
</div>